import styled from 'styled-components';

import {
  Color,
  FontWeight,
  FontSize,
  LineHeight,
} from '@pushwoosh/kit-constants';

export const FormStyled = styled.form`
  > * + * {
    &:not(:empty) {
      margin-top: 24px;
    }
  }
`;

export const InputFieldsBox = styled.div`
  display: flex;
  flex-direction: column;
  color: ${Color.MAIN};

  > * + * {
    margin-top: 16px;
  }
`;

export const InfoNote = styled.div`
  color: ${Color.LOCKED};
  font-weight: ${FontWeight.REGULAR};
  font-size: ${FontSize.REGULAR};
  line-height: ${LineHeight.REGULAR};
  text-align: left;
`;
